var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"login mx-auto"},[_c('b-overlay',{attrs:{"show":!_vm.requiredResourcesLoaded,"variant":_vm.themeStore.primaryColor}},[_c('div',{attrs:{"id":"okta-signin-container"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }